// src/compoents/layout/Footer.jsx
import { siteMeta } from "../data/siteContent";

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="container-shell footer-shell">
        <div className="footer-top-card">
          <div className="footer-brand">
            <img src={siteMeta.logo} alt="Dryvziro" className="footer-logo" />
            <div>
              <h2>Dryvziro</h2>
              <p>
                Transforming transport emissions into measurable climate action.
              </p>
            </div>
          </div>

          <a
            href={siteMeta.ctaHref}
            target="_blank"
            rel="noreferrer"
            className="btn btn--primary"
          >
            {siteMeta.ctaLabel}
          </a>
        </div>

        <div className="footer-grid">
          <div>
            <h4>Contact</h4>
            <ul>
              <li>gokijany@electrixitaty.com</li>
              <li>+254 705 247 958</li>
              <li>Nairobi, Kenya</li>
            </ul>
          </div>

          <div>
            <h4>Navigate</h4>
            <ul>
              <li>
                <a href="#hero">About</a>
              </li>
              <li>
                <a href="#model">Model</a>
              </li>
              <li>
                <a href="#impact">Impact</a>
              </li>
              <li>
                <a href="#portfolio">Portfolio</a>
              </li>
            </ul>
          </div>

          <div>
            <h4>Technology</h4>
            <ul>
              <li>
                <a href="#technology">Transparency</a>
              </li>
              <li>
                <a href="#partners">Partners</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© 2026 Dryvziro</span>
          <div>
            <a href="#">Privacy Policy</a>
            <a href="#">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
